export const PLANS = {
  PREMIUM: 'premium_plan_v36',
  PRO: 'pro_plan_v36',
  STARTER: 'starter_plan_v36'
};

export const PLANS_LIST = [PLANS.STARTER, PLANS.PRO, PLANS.PREMIUM];
export const MOBILE_PLANS_LIST = [PLANS.PRO, PLANS.PREMIUM, PLANS.STARTER];
